// Mode-aware copy + CTA + feature flag config.
// One engine, three faces — voice tuned to The Weave: trusted guide,
// calm confidence, community-centred, optimistic but grounded.

export const MODE_CONFIG = {
  mba: {
    label: "MBA Simulation",
    eyebrow: "Simulation Mode",
    headline: "Slow the frame. Inspect the system. Choose the next move.",
    sub: "A quiet, structured way to work through your simulation scenario — without the noise.",
    intro: "Built for the M&A simulation week. Your analysis stays on your screen — private, practical, yours.",
    primaryCta: "Start your decision",
    secondaryCta: "Return to simulation",
    showEmailCapture: false,
    showTeamTag: true,
    showLockedMap: false,
    showMemberMap: false,
    showMemberDashboardLink: false,
    showJoinCta: false,
    footerNote: "PISA Decision Room — quietly supporting your simulation week. Outputs stay with you.",
    askEmailAtEntry: true,
  },
  public: {
    label: "Public",
    eyebrow: "Public Edition",
    headline: "Better decisions start with a slower frame.",
    sub: "PISA is a private thinking tool from The Weave — built to help founders see the system, the power, and the bias before they act.",
    intro: "This is the starting point. Inside the 1% Club, your Founder Decision Map shows how your judgment grows across real decisions — together with founders who get it.",
    primaryCta: "Unlock the Founder Decision Map",
    secondaryCta: "Continue inside the 1% Club",
    showEmailCapture: true,
    showTeamTag: false,
    showLockedMap: true,
    showMemberMap: false,
    showMemberDashboardLink: false,
    showJoinCta: true,
    footerNote: "You don't have to build alone. Inside the 1% Club, these decisions connect — and so do the founders making them.",
    askEmailAtEntry: false,
  },
  member: {
    label: "1% Club Member",
    eyebrow: "1% Club · Member",
    headline: "Welcome back. Let's think this one through together.",
    sub: "Your decisions are building a clearer pattern. Pin this — and come back to it when reality shifts.",
    intro: "Use PISA to think through this decision. It will be saved to your Founder Decision Map, with the rest of your thinking.",
    primaryCta: "View your Founder Decision Map",
    secondaryCta: "Back to your dashboard",
    showEmailCapture: false,
    showTeamTag: false,
    showLockedMap: false,
    showMemberMap: true,
    showMemberDashboardLink: true,
    showJoinCta: false,
    footerNote: "Looking for something new? Tell us what you're searching for — maybe we'll have an answer soon.",
    askEmailAtEntry: false,
  },
};

export const SCENARIO_CHIPS = [
  "M&A",
  "Negotiation",
  "Fundraising",
  "Sales",
  "Board / leadership",
  "Hiring / team",
  "Something else",
];
